import axios from 'axios'

export const namespaced = true

export const state = {
  loggedIn: false,
  loading: false,
  haskoningLoading: false
}

export const mutations = {
  SET_LOGIN(state, login) {
    state.loggedIn = login
  },
  SET_LOADING(state, payload) {
    state.loading = payload
  },
  SET_HASKONING_LOADING(state, payload) {
    state.haskoningLoading = payload
  }
}

export const actions = {
  setLoggedIn(context, login = false) {
    context.commit('SET_LOGIN', login)
  },
  async authenticate(context, { username, password }) {
    const baseUrl = import.meta.env.VITE_APP_API_BASE_URL
    let url = baseUrl + 'api/token/'
    let requestData = {
      username: username,
      password: password
    }
    let response = await axios.post(url, requestData)
    const accessToken = response.data.access
    const refreshToken = response.data.refresh
    localStorage.setItem('access', accessToken)
    localStorage.setItem('refresh', refreshToken)
    await context.dispatch('users/fetchUser', null, { root: true })
    context.commit('SET_LOGIN', true)
  },
  logout(context) {
    context.commit('SET_LOGIN', false)
    localStorage.removeItem('access')
    localStorage.removeItem('refresh')
    context.dispatch('users/setUser', null, { root: true })
  },
  setHaskoningLoading(context, payload) {
    context.commit('SET_HASKONING_LOADING', payload)
  },
  setLoading(context, payload) {
    context.commit('SET_LOADING', payload)
  }
}
